import { render } from "./Canais.vue?vue&type=template&id=7bc94e7d"
import script from "./Canais.vue?vue&type=script&lang=js"
export * from "./Canais.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__